import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from  '@angular/forms';
import { Router } from '@angular/router';
import { ChangePasswordModel } from 'src/app/models/login/changePassword.model';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  changePassword: ChangePasswordModel;
  Loader: boolean = false;

  constructor(private localstorage:LocalstorageService, private alertify:AlertifyService, private router:Router, private _loginService: LoginService)
   {
     this.changePassword = new ChangePasswordModel();
    }

  ngOnInit() {
  }

  onSubmit(): void {
    if (this.changePassword.Password == "" || this.changePassword.Password == null || this.changePassword.Password == undefined) {
      this.alertify.error("Password is required");
      return;
    }
    this.Loader = true;
    this._loginService.changePassword(this.changePassword).subscribe(res => {
      var responseData = JSON.parse(res._body);
        if (responseData.isSuccess)
          {
            this.changePassword = responseData.responseData;
            this.localstorage.setToken(responseData.responseData.token);
            this.localstorage.setname(responseData.responseData.OldPassword);
            this.localstorage.setUserRole(responseData.responseData.usertype);
            this.localstorage.setUserId(responseData.responseData.userId);     
            this.alertify.success(responseData.responseMessage);
            this.Loader = false;
            this.router.navigate(['login']);
          }
          else 
          {
            this.alertify.error(responseData.responseMessage);
            this.Loader = false;
          }
      },
    )
  }
  cancel(){
    this.router.navigate(['/dashboard/']);
  }
}
